import api from './api';
import { User } from '../types/user';
import { handleError } from '../utils/errorHandler';

// **GET**: Lista todos os usuários
export const getUsers = async (): Promise<User[]> => {
  try {
    const response = await api.get<{ results: User[] }>('/core/users/');
    return response.data.results;
  } catch (error) {
    handleError(error, 'ao obter usuários');
    throw error;
  }
};

export const toggleUserActive = async (id: number, isActive: boolean): Promise<User> => {
  try {
    const response = await api.patch<User>(`/core/users/${id}/`, { is_active: isActive });
    return response.data;
  } catch (error) {
    handleError(error, `ao ${isActive ? 'ativar' : 'desativar'} usuário`);
    throw error;
  }
};

export const getUserById = async (id: number): Promise<User> => {
  try {
    const response = await api.get<User>(`/core/users/${id}/`);
    return response.data;
  } catch (error) {
    handleError(error, 'ao buscar usuário');
    throw error;
  }
};

export const createUser = async (userData: Partial<User>): Promise<User> => {
  try {
    const response = await api.post<User>('/core/users/', userData);
    return response.data;
  } catch (error) {
    handleError(error, 'ao criar usuário');
    throw error;
  }
};

export const updateUser = async (id: number, userData: Partial<User>): Promise<User> => {
  try {
    const response = await api.put<User>(`/core/users/${id}/`, userData);
    return response.data;
  } catch (error) {
    handleError(error, 'ao atualizar usuário');
    throw error;
  }
};

export const deleteUser = async (id: number): Promise<void> => {
  try {
    await api.delete(`/core/users/${id}/`);
  } catch (error) {
    handleError(error, 'ao deletar usuário');
    throw error;
  }
};